module.exports = __webpack_public_path__ + "media/social/link-instagram-3839c3e3.png";